import type { ReactNode } from 'react'

import { ErrorBoundary } from 'common/components/FallbackComponent/ErrorBoundary/ErrorBoundary'

export const withErrorBoundary = (component: () => ReactNode) => () =>
  <ErrorBoundary>{component()}</ErrorBoundary>
